import React, { FC, useRef } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserRole } from "@green0meter/api-client";

import { CO2_CONFIG } from "./config";

import { Co2Guide, Co2Recommendations, Co2MyUploads } from "@components/main/co2";
import WelcomeBannerContainer from "@components/main/co2/hub/WelcomeBanner";
import CollectData from "@components/main/co2/hub/CollectData/CollectData";
import ReportsContainer from "@components/main/co2/hub/Reports";
import Overview from "@components/main/co2/hub/Overview";
import { Grid } from "@components/base";
import { DemoDataAlert } from "@components/common";
import { useUserStore } from "@store/user";

const Co2HubPage: FC = () => {
  const { t } = useTranslation();
  const reportsRef = useRef<HTMLDivElement>(null);
  const uploadsRef = useRef<HTMLDivElement>(null);
  const { user } = useUserStore();

  const isNotRespondent = user?.role !== UserRole.Respondent;
  const isViewer = user?.role === UserRole.Viewer;
  const isAuditor = user?.role === UserRole.Auditor;

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <WelcomeBannerContainer
          title={t(CO2_CONFIG.welcomeBanner.titleKey)}
          text={t(CO2_CONFIG.welcomeBanner.textKey)}
          color={CO2_CONFIG.welcomeBanner.color}
          icon={CO2_CONFIG.welcomeBanner.icon}
        />
        {!isViewer && !isAuditor && (
          <Grid size={12}>
            <Co2Guide
              refs={{
                reportsRef,
                uploadsRef,
              }}
            />
          </Grid>
        )}
        {!isViewer && (
          <Grid size={12}>
            <CollectData
              formBaseType={CO2_CONFIG.formBaseType}
              titleKey={t(CO2_CONFIG.collectData.titleKey)}
              descriptionKey={t(CO2_CONFIG.collectData.descriptionKey)}
              color={CO2_CONFIG.collectData.color}
              icon={CO2_CONFIG.collectData.icon}
              buttonTextKey={t(CO2_CONFIG.collectData.buttonTextKey)}
              noFormsTextKey={t(CO2_CONFIG.collectData.noFormsTextKey)}
            />
          </Grid>
        )}
        {isNotRespondent && !isViewer && (
          <Grid size={12} ref={reportsRef}>
            <ReportsContainer
              formBaseType={CO2_CONFIG.formBaseType}
              title={t(CO2_CONFIG.reports.titleKey)}
              type={CO2_CONFIG.reports.type}
              noReportsText={t(CO2_CONFIG.reports.noReportsTextKey)}
              fillFormText={t(CO2_CONFIG.reports.fillFormTextKey)}
            />
          </Grid>
        )}
        {isNotRespondent && !isViewer && !isAuditor && <DemoDataAlert />}
        {isNotRespondent && (
          <Grid size={12}>
            <Overview
              title={t(CO2_CONFIG.overview.titleKey)}
              dashboardPath={CO2_CONFIG.overview.dashboardPath}
              viewDashboardText={t(CO2_CONFIG.overview.viewDashboardTextKey)}
              reportPageId={CO2_CONFIG.overview.reportPageId}
            />
          </Grid>
        )}
        {isNotRespondent && !isViewer && !isAuditor && (
          <Grid size={12}>
            <Co2Recommendations />
          </Grid>
        )}
        {!isViewer && !isAuditor && (
          <Grid size={{ md: 6, xs: 12 }}>
            <Co2MyUploads />
          </Grid>
        )}
        {/*<Grid size={{ md: 6, xs: 12 }} ref={uploadsRef}>
          <Co2UploadData />
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default Co2HubPage;
